var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('scoring-drill-math',{attrs:{"problems":_vm.problems,"resultProblem":_vm.resultProblem,"isReport":_vm.isReport,"reportRole":_vm.reportRole}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }